import { render } from "./InstrumentQueue.vue?vue&type=template&id=667314fb"
import script from "./InstrumentQueue.vue?vue&type=script&lang=js"
export * from "./InstrumentQueue.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/instrumentQueue/InstrumentQueue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "667314fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('667314fb', __exports__)) {
    console.log('reload')
    api.reload('667314fb', __exports__)
  }
  
  module.hot.accept("./InstrumentQueue.vue?vue&type=template&id=667314fb", () => {
    console.log('re-render')
    api.rerender('667314fb', render)
  })

}


export default __exports__